<div style="background-color: white;">
	<div class="modal-header">
		<button (click)="shouldUpdateSynthesis(false)" aria-label="Close" class="close" type="button">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		{{ visualiserMessages.popupEnregistrerDesc | translate }}
	</div>
	<div class="modal-footer">
		<button (click)="shouldUpdateSynthesis(false)" class="btn btn-outline-primary mr-1" type="button">
			{{ visualiserMessages.annuler | translate }}
		</button>
		<button (click)="shouldUpdateSynthesis(true)" class="btn btn-primary mr-1" type="button">
			{{ visualiserMessages.enregistrer | translate }}
		</button>
	</div>
</div>